import { colors } from '@dixa/lib-shared-tokens';

const connectionToStatusValue = {
  CONNECTED: {
    icon: 'check-circle-filled',
    color: colors.green[500],
    tooltip: 'Connected',
  },
  CONNECTING: {
    icon: 'sync',
    color: colors.neutral[500],
    tooltip: 'Connecting..',
  },
  CONNECTION_TIMEOUT: {
    icon: 'exclamation-triangle-filled',
    color: colors.red[200],
    tooltip: 'Connection timeout',
  },
  CONNECTION_FAILED: {
    icon: 'close-circle-filled',
    color: colors.red[500],
    tooltip: 'Connection failed',
  },
  NOT_CONNECTED: {
    icon: 'exclamation-circle-filled',
    color: colors.neutral[500],
    tooltip: 'Not connected',
  },
} as const;

type StatusValues =
  (typeof connectionToStatusValue)[keyof typeof connectionToStatusValue];

export type ConnectionType =
  | 'CONNECTING'
  | 'CONNECTED'
  | 'CONNECTION_TIMEOUT'
  | 'CONNECTION_FAILED'
  | 'NOT_CONNECTED';

export const getConnectionStatusValues = (
  status: ConnectionType,
): StatusValues => connectionToStatusValue[status];
